var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.tagsLoaded
        ? _c("DropdownFilter", {
            attrs: {
              withoutLoading: "",
              placeholder: "Select tag",
              value: _vm.selectedTag,
              customMultiStyleParent: _vm.getcontainerStyle,
              multiple: false,
              options: _vm.tags,
            },
            on: { input: _vm.update },
          })
        : _c("InputPlaceholder"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }